// extracted by mini-css-extract-plugin
export default {"loaderContainer":"tournamentNavigationHelper_loaderContainer__RtmKy"};